/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { RowNode } from 'ag-grid-community';
import { GridCellRendererComponent } from '../../cell-components/grid-component.interfaces';
import { GridSelection, GridSelector } from './grid-selectable.interfaces';

@Component({
  selector: 'gh-grid-multiple-selector',
  template: `
    <mat-checkbox color="primary"
                  [disabled]="!selectable"
                  [checked]="checked"
                  (click)="onClick($event)"
                  (change)="onChange($event)"
    ></mat-checkbox>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridMultipleSelectorComponent implements OnInit, OnDestroy, GridCellRendererComponent, GridSelector {
  id: any;
  node: RowNode;
  private selection: GridSelection;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    this.refreshSelection = this.refreshSelection.bind(this);
  }

  get checked(): boolean {
    return this.selection.isSelected(this.id);
  }

  get selectable(): boolean {
    return this.selection.isSelectable(this.node.data);
  }

  ngOnInit(): void {
    this.selection.addSelector(this.id, this);
  }

  ngOnDestroy(): void {
    this.selection.removeSelector(this.id);
    this.node.removeEventListener(RowNode.EVENT_DATA_CHANGED, this.refreshSelection);
  }

  agInit(params: any): void {
    this.selection = params.selection;
    this.id = params.node.id;
    this.node = params.node;

    this.node.addEventListener(RowNode.EVENT_DATA_CHANGED, this.refreshSelection);
  }

  refresh(params: any): boolean {
    this.changeDetectorRef.markForCheck();
    return true;
  }

  refreshSelection(): void {
    this.changeDetectorRef.markForCheck();
  }

  onChange(event: any): void {
    if (this.selection.isOutsideHandle()) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    this.selection.select(this.id, !this.checked);
  }

  onClick(event: any): void {
    if (this.selection.isOutsideHandle()) {
      event.stopPropagation();
      event.preventDefault();
      this.selection.select(this.id, !this.checked);
    }
  }
}
